export default __webpack_public_path__ + "static/media/1630.677ab694.png";